import React from "react";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <header className="nw-hero" id="top">
      <div className="nw-hero-grid">
        <div className="nw-hero-copy">
          <p className="nw-eyebrow">{t("hero.eyebrow")}</p>
          <h1>{t("hero.title")}</h1>
          <p className="nw-lead">{t("hero.description")}</p>
          <div className="nw-hero-actions">
            <a className="btn primary" href="#contact">
              {t("hero.ctaContact")}
            </a>
            <a className="btn ghost" href="#youtube">
              {t("hero.ctaYoutube")}
            </a>
          </div>
          <div className="nw-hero-social">
            <a
              href="https://www.youtube.com/@kalendaproject"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                <path
                  d="M10 8l6 4-6 4V8zm11-1.5c-.3-1.2-1.2-2.1-2.4-2.4C16.7 3.6 12 3.6 12 3.6s-4.7 0-6.6.5C4.2 4.4 3.3 5.3 3 6.5 2.5 8.4 2.5 12 2.5 12s0 3.6.5 5.5c.3 1.2 1.2 2.1 2.4 2.4 1.9.5 6.6.5 6.6.5s4.7 0 6.6-.5c1.2-.3 2.1-1.2 2.4-2.4.5-1.9.5-5.5.5-5.5s0-3.6-.5-5.5z"
                  fill="currentColor"
                />
              </svg>
              <span>YouTube</span>
            </a>
            <a
              href="https://www.instagram.com/kalendaproject"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                <path
                  d="M7 3h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4zm10 2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2zm-5 3.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.5-.9a.9.9 0 11.001 1.801A.9.9 0 0116.5 9.6z"
                  fill="currentColor"
                />
              </svg>
              <span>Instagram</span>
            </a>
            {/* <a
              href="https://www.spotify.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Spotify"
            >
              <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                <path
                  d="M12 0.8C5.9 0.8 0.8 5.9 0.8 12S5.9 23.2 12 23.2 23.2 18.1 23.2 12 18.1 0.8 12 0.8zm5.3 16.2c-.2.3-.6.4-.9.2-2.5-1.5-5.7-1.9-9.4-1.1-.4.1-.7-.2-.8-.5-.1-.4.2-.7.5-.8 4-.9 7.5-.5 10.3 1.3.4.2.4.6.3.9zm1.3-2.8c-.3.4-.8.5-1.2.2-2.9-1.8-7.3-2.3-10.6-1.3-.5.1-1-.1-1.1-.6-.1-.5.1-1 .6-1.1 3.9-1.2 8.7-.6 12.1 1.5.4.3.5.8.2 1.3zm.1-3c-3.4-2-9-2.2-12.3-1.2-.6.2-1.2-.1-1.4-.7-.2-.6.1-1.2.7-1.4 3.8-1.2 10.1-1 14 1.4.5.3.7 1 .4 1.5-.3.5-1 .7-1.5.4z"
                  fill="currentColor"
                />
              </svg>
              <span>Spotify</span>
            </a> */}
          </div>
        </div>
        <div className="nw-hero-banner">
          <div className="nw-banner-inner">
            <span className="nw-banner-title">Northwind Audio</span>
            <div className="nw-wave" />
            <p>{t("hero.bannerText")}</p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Hero;
